import moment from 'moment';
import localeEn from 'air-datepicker/locale/en';
import localeRu from 'air-datepicker/locale/ru';
import localeFr from 'air-datepicker/locale/fr';
import localeDe from 'air-datepicker/locale/de';
import localeEs from 'air-datepicker/locale/es';
import localeNl from 'air-datepicker/locale/nl';
import localeIt from 'vue2-datepicker/locale/it';
import localeAr from 'vue2-datepicker/locale/ar';

const localeKk = {
    days: ['Жексенбі', 'Дүйсенбі', 'Сейсенбі', 'Сәрсенбі', 'Бейсенбі', 'Жұма', 'Сенбі'],
    daysShort: ['Жек', 'Дүй', 'Сей', 'Сәр', 'Бей', 'Жұм', 'Сен'],
    daysMin: ['Жс', 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн'],
    months: [
        'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым',
        'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'
    ],
    monthsShort: ['Қаң', 'Ақп', 'Нау', 'Сәу', 'Мам', 'Мау', 'Шіл', 'Там', 'Қыр', 'Қаз', 'Қар', 'Жел'],
    today: 'Бүгін',
    clear: 'Тазалау',
    dateFormat: 'yyyy-MM-dd',
    timeFormat: 'HH:mm',
    firstDay: 1
};

export const AirDatePickerMixin = {
    data() {
        return {
            locale: localeEn,
            calendarSheetLength: 34,
        };
    },
    methods: {
        /*
         * set language locale for air-datepicker
         */
        setLocale() {
            switch (this.$root.currentLanguage) {
                case 'ru':
                    this.locale = localeRu;
                    break;
                case 'en':
                    this.locale = localeEn;
                    break;
                case 'fr':
                    this.locale = localeFr;
                    break;
                case 'de':
                    this.locale = localeDe;
                    break;
                case 'es':
                    this.locale = localeEs;
                    break;
                case 'nl':
                    this.locale = localeNl;
                    break;
                case 'it':
                    this.locale = localeIt;
                    break;
                case 'ar':
                    this.locale = localeAr;
                    break;
                case 'kz':
                    this.locale = localeKk;
                    break;
                default:
                    this.locale = localeEn;
                    break;
            }
        },
        getDatepickerDatesRange(startDate) {
            return {
                start: moment(startDate).format('YYYY-MM-DD'),
                end: moment(startDate).add(this.calendarSheetLength, 'day').format('YYYY-MM-DD'),
            };
        }
    },
};

